const getters = {
  types: state => state.types,
  typeById: state => (id) => state.types.find(type => type.id === id) || {name: 'Не известно', id: null}
};

export default getters;